/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unresolved asset-scoped observation queue row (MDM-MATCH.32 admin)
 * @export
 * @interface MdmUnresolvedObservationDto
 */
export interface MdmUnresolvedObservationDto {
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    integrationInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    executionId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    observationRoute?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    reasonCode?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationDto
     */
    retryCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    lastRetryAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    nextRetryAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationDto
     */
    resolvedAssetGoldenId?: string;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    resolvedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    observedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmUnresolvedObservationDto
     */
    updatedAt?: Date;
    /**
     * Asset linkage keys extracted for resolution (hardware_uuid, image_digest, …)
     * @type {{ [key: string]: any; }}
     * @memberof MdmUnresolvedObservationDto
     */
    assetLinkage?: { [key: string]: any; };
    /**
     * Summary fields from normalized payload (e.g. cve_id, title)
     * @type {{ [key: string]: any; }}
     * @memberof MdmUnresolvedObservationDto
     */
    payloadSummary?: { [key: string]: any; };
    /**
     * Full normalized payload; present on detail responses only
     * @type {{ [key: string]: any; }}
     * @memberof MdmUnresolvedObservationDto
     */
    normalizedPayload?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MdmUnresolvedObservationDto interface.
 */
export function instanceOfMdmUnresolvedObservationDto(value: object): value is MdmUnresolvedObservationDto {
    return true;
}

export function MdmUnresolvedObservationDtoFromJSON(json: any): MdmUnresolvedObservationDto {
    return MdmUnresolvedObservationDtoFromJSONTyped(json, false);
}

export function MdmUnresolvedObservationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmUnresolvedObservationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'integrationInstanceId': json['integrationInstanceId'] == null ? undefined : json['integrationInstanceId'],
        'executionId': json['executionId'] == null ? undefined : json['executionId'],
        'observationRoute': json['observationRoute'] == null ? undefined : json['observationRoute'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'reasonCode': json['reasonCode'] == null ? undefined : json['reasonCode'],
        'retryCount': json['retryCount'] == null ? undefined : json['retryCount'],
        'lastRetryAt': json['lastRetryAt'] == null ? undefined : (new Date(json['lastRetryAt'])),
        'nextRetryAt': json['nextRetryAt'] == null ? undefined : (new Date(json['nextRetryAt'])),
        'resolvedAssetGoldenId': json['resolvedAssetGoldenId'] == null ? undefined : json['resolvedAssetGoldenId'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'observedAt': json['observedAt'] == null ? undefined : (new Date(json['observedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'assetLinkage': json['assetLinkage'] == null ? undefined : json['assetLinkage'],
        'payloadSummary': json['payloadSummary'] == null ? undefined : json['payloadSummary'],
        'normalizedPayload': json['normalizedPayload'] == null ? undefined : json['normalizedPayload'],
    };
}

export function MdmUnresolvedObservationDtoToJSON(json: any): MdmUnresolvedObservationDto {
    return MdmUnresolvedObservationDtoToJSONTyped(json, false);
}

export function MdmUnresolvedObservationDtoToJSONTyped(value?: MdmUnresolvedObservationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'integrationInstanceId': value['integrationInstanceId'],
        'executionId': value['executionId'],
        'observationRoute': value['observationRoute'],
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'reasonCode': value['reasonCode'],
        'retryCount': value['retryCount'],
        'lastRetryAt': value['lastRetryAt'] == null ? undefined : ((value['lastRetryAt']).toISOString()),
        'nextRetryAt': value['nextRetryAt'] == null ? undefined : ((value['nextRetryAt']).toISOString()),
        'resolvedAssetGoldenId': value['resolvedAssetGoldenId'],
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt']).toISOString()),
        'observedAt': value['observedAt'] == null ? undefined : ((value['observedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'assetLinkage': value['assetLinkage'],
        'payloadSummary': value['payloadSummary'],
        'normalizedPayload': value['normalizedPayload'],
    };
}

